<template>
  <van-popup overlay-class="dialog-box--overlay" position="bottom" class="dialog-box" v-model="show">
     <div class="content">
        <div class="header">
          <div class="header--title">{{ title }}</div>
          <div @click="close" class="closeIcon">x</div>
        </div>
        <div class="iframeContent">
          <iframe :src="url" class="iframeBox"></iframe>
        </div>
      </div>
  </van-popup>
</template>

<script>
export default {
  data() {
    return {
      show: false,
    };
  },
  props: {
    url: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "提示",
    },
  },
  methods: {
    open() {
      this.show = true;
    },
    close() {
      this.show = false;
    },
  },
};
</script>

<style lang="scss">
.dialog-box--overlay {
    background: rgba($color: #000000, $alpha: 0.2);
}
</style>

<style lang="scss" scoped>
.dialog-box {
  width: 100%;
  height: 90vh;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
.content {
  position: absolute;
  bottom: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background-color: #fff;
  border-top-right-radius: 5px;
  border-top-left-radius: 5px;
  overflow: hidden;

  .header {
    padding-left: 10px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .closeIcon {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 50px;
      font-size: 20px;
      height: 50px;
    }
  }
  .header--title{
    font-weight: bold;
  }

  .iframeContent {
    flex: 1;
    overflow: hidden;

    .iframeBox {
      width: 100%;
      height: 100%;
      overflow: auto;
    }
  }
}
</style>
